module.exports = __webpack_public_path__ + "img/avatar.a65d9684.png";